import { render, staticRenderFns } from "./IdexRemoved.vue?vue&type=template&id=2dfe5208&scoped=true&"
import script from "./IdexRemoved.vue?vue&type=script&lang=js&"
export * from "./IdexRemoved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe5208",
  null
  
)

export default component.exports